import { all, call, put, takeLatest } from "redux-saga/effects";

import { getErrorMessage } from "../../../../utils/sagasErrorHandler";
import { sharedHistory } from "../../../../routes/sharedHistory";
import { ROUTES_MAP } from "../../../../routes/constants";

import {
    getUsersRolesSuccess,
    getUsersRolesError,
    getUsersRoles,
    getActionsForRole,
    getActionsForRoleError,
    getActionsForRoleSuccess,
    getRoleByID,
    getRoleByIDSuccess,
    getRoleByIDError,
    createRole,
    updateRole,
    createRoleError,
    createRoleSuccess,
    updateRoleSuccess,
    updateRoleError,
    deleteRoleSuccess,
    deleteRoleError,
    deleteRole
} from "./actions";
import {
    createRoleRequest,
    deleteRoleRequest,
    getActionsForRoleRequest,
    getRoleRoleByIDRequest,
    getRolesRequest,
    updateRoleRequest
} from "./api";

//Workers
function* handleGetRoles () {
    try {
        const rolesData = yield call(getRolesRequest);

        yield put(getUsersRolesSuccess(rolesData));
    } catch (error) {
        yield put(getUsersRolesError());
        getErrorMessage(error);
    }
}

function* handleGetRoleByID ({ payload }) {
    try {
        const roleData = yield call(getRoleRoleByIDRequest, payload);

        yield put(getRoleByIDSuccess(roleData));
    } catch (error) {
        yield put(getRoleByIDError());
        getErrorMessage(error);
    }
}

function* handleGetActionsForRole () {
    try {
        const { auth_policy_definitions } = yield call(getActionsForRoleRequest);

        yield put(getActionsForRoleSuccess(auth_policy_definitions));
    } catch (error) {
        yield put(getActionsForRoleError());
        getErrorMessage(error);
    }
}

function* handleCreateRole ({ payload }) {
    try {
        yield call(createRoleRequest, payload);

        yield put(createRoleSuccess());
        sharedHistory.push(ROUTES_MAP.roles.path);
    } catch (error) {
        yield put(createRoleError());
        getErrorMessage(error);
    }
}

function* handleUpdateRole ({ payload }) {
    try {
        yield call(updateRoleRequest, payload);

        yield put(updateRoleSuccess());
        sharedHistory.push(ROUTES_MAP.roles.path);
    } catch (error) {
        yield put(updateRoleError());
        getErrorMessage(error);
    }
}

function* handleDeleteRole ({ payload }) {
    try {
        yield call(deleteRoleRequest, payload);

        yield put(deleteRoleSuccess());
        yield put(getUsersRoles());
    } catch (error) {
        yield put(deleteRoleError());
        getErrorMessage(error);
    }
}

// Watchers
export function* rolesEntriesSagas() {
    yield all([
        yield takeLatest(getUsersRoles, handleGetRoles),
        yield takeLatest(getRoleByID, handleGetRoleByID),
        yield takeLatest(getActionsForRole, handleGetActionsForRole),
        yield takeLatest(createRole, handleCreateRole),
        yield takeLatest(updateRole, handleUpdateRole),
        yield takeLatest(deleteRole, handleDeleteRole)
    ]);
}
